import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const SearchHeader = ({ 
  searchQuery, 
  onSearchChange, 
  onSearch, 
  sortBy, 
  onSortChange, 
  viewMode, 
  onViewModeChange, 
  resultsCount, 
  onToggleFilters,
  isFiltersOpen 
}) => {
  const [localSearchQuery, setLocalSearchQuery] = useState(searchQuery || '');

  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'duration', label: 'Duration' },
    { value: 'popularity', label: 'Most Popular' },
    { value: 'newest', label: 'Newest First' }
  ];

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    onSearch(localSearchQuery);
  };

  const handleSearchInputChange = (e) => {
    setLocalSearchQuery(e?.target?.value);
    onSearchChange(e?.target?.value);
  };

  return (
    <div className="bg-white border-b border-border sticky top-20 z-30">
      <div className="px-4 lg:px-6 py-4">
        {/* Search Bar */}
        <form onSubmit={handleSearchSubmit} className="mb-4">
          <div className="relative max-w-2xl">
            <Input
              type="search"
              placeholder="Search destinations, tours, activities..."
              value={localSearchQuery}
              onChange={handleSearchInputChange}
              className="w-full pl-12 pr-4 py-3 rounded-lg border-2 border-muted focus:border-primary"
            />
            <Icon 
              name="Search" 
              size={20} 
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
            />
            <Button
              type="submit"
              size="sm"
              className="absolute right-2 top-1/2 transform -translate-y-1/2"
            >
              Search
            </Button>
          </div>
        </form>

        {/* Controls Bar */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          {/* Left Side - Results Count & Filter Toggle */}
          <div className="flex items-center space-x-4">
            <Button
              variant="outline"
              size="sm"
              onClick={onToggleFilters}
              iconName={isFiltersOpen ? "X" : "Filter"}
              iconPosition="left"
              className="lg:hidden"
            >
              {isFiltersOpen ? 'Close' : 'Filters'}
            </Button>
            
            <div className="text-sm text-muted-foreground">
              <span className="font-medium text-foreground">{resultsCount?.toLocaleString()}</span> tours found
            </div>
          </div>

          {/* Right Side - Sort & View Controls */}
          <div className="flex items-center space-x-3">
            {/* Sort Dropdown */}
            <div className="flex items-center space-x-2">
              <span className="text-sm text-muted-foreground hidden sm:block">Sort by:</span>
              <Select
                options={sortOptions}
                value={sortBy}
                onChange={onSortChange}
                placeholder="Sort by"
                className="min-w-[140px]"
              />
            </div>

            {/* View Mode Toggle */}
            <div className="flex items-center bg-muted rounded-lg p-1">
              <button
                onClick={() => onViewModeChange('list')}
                className={`p-2 rounded-md transition-colors ${
                  viewMode === 'list' ?'bg-white text-primary shadow-sm' :'text-muted-foreground hover:text-foreground'
                }`}
                title="List View"
              >
                <Icon name="List" size={18} />
              </button>
              <button
                onClick={() => onViewModeChange('grid')}
                className={`p-2 rounded-md transition-colors ${
                  viewMode === 'grid' ?'bg-white text-primary shadow-sm' :'text-muted-foreground hover:text-foreground'
                }`}
                title="Grid View"
              >
                <Icon name="Grid3X3" size={18} />
              </button>
              <button
                onClick={() => onViewModeChange('map')}
                className={`p-2 rounded-md transition-colors ${
                  viewMode === 'map' ?'bg-white text-primary shadow-sm' :'text-muted-foreground hover:text-foreground'
                }`}
                title="Map View"
              >
                <Icon name="Map" size={18} />
              </button>
            </div>
          </div>
        </div>

        {/* Active Search Query Display */}
        {searchQuery && (
          <div className="mt-3 flex items-center space-x-2">
            <span className="text-sm text-muted-foreground">Searching for:</span>
            <span className="text-sm font-medium text-primary bg-primary/10 px-2 py-1 rounded-md">
              "{searchQuery}"
            </span>
            <button
              onClick={() => {
                setLocalSearchQuery('');
                onSearch('');
              }}
              className="text-muted-foreground hover:text-foreground"
            >
              <Icon name="X" size={16} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchHeader;